import React from 'react';

import { IconButton, TooltipWrapper } from '@zapier/design-system';

type Props = {
  message: string;
};

function LockedNavCog({ message }: Props) {
  return (
    <TooltipWrapper content={message}>
      {() => (
        <IconButton
          aria-label="More actions"
          isDisabled={true}
          name="navMoreHoriz"
          variant="ghost"
        />
      )}
    </TooltipWrapper>
  );
}

export default LockedNavCog;
